/**
 * 🎨 Presenter Class
 * Gère l'affichage du diaporama, les animations, et les transitions.
 */
export default class Presenter {
    constructor() {
        // 🏗️ Initialisation des éléments du DOM et des variables d'état
        this.show = $('#show');
        this.data = this.show.data();
        this.debug = true; // 🐛 Mode debug global
        this.debugOptions = {
            'DISPLAY':  true, // Lancement de slides/photos
            'CANVAS':   true, // Animations Canvas
            'PHOTO':    true, // Gestion des photos
            'SLIDE':    true, // Gestion des diapositives
            'MODE':     true, // Changements de mode (Photo/Slide)
            'TIME':     false, // Timers et intervalles
            'BG':       false, // Changements de fond
            'VIDEO':    true, // Playback vidéo
            'IFRAME':   true, // Signaux iframe
            'CLEANUP':  false, // Déchargement de ressources
            'ERROR':    true  // Erreurs
        };
        this.started = false;

        // Diapositives
        this.slideimagicalFantasyDuration = this.data.slideDuration;
        this.slideNb = this.data.slideNb;

        this.slideAnimIn = this.data.slideAnimIn;
        this.slideAnimInDuration = this.data.slideAnimInDuration;
        this.slideAnimOut = this.data.slideAnimOut;
        this.slideAnimOutDuration = this.data.slideAnimOutDuration;

        this.slideCounter = 0;
        this.slideCurrent = -1;
        this.slideTotal = 0;

        this.slideMode = false;

        // Photos
        this.photoSrc = this.data.photoSrc;
        this.photoDuration = this.data.photoDuration;
        this.photoNb = this.data.photoNb;

        this.photoAnimIn = this.data.photoAnimIn;
        this.photoAnimInDuration = this.data.photoAnimInDuration;
        this.photoAnimOut = this.data.photoAnimOut;
        this.photoAnimOutDuration = this.data.photoAnimOutDuration;

        this.photoCounter = this.photoNb + 1; // Forcer démarrage en mode logo
        this.photoCurrent = 0;
        this.photoTotal = 0;

        // 🖼️ Gestion des images
        this.images = {};
        this.imagesName = {};

        // ➕ Ajout de nouvelles images
        this.addNew = false;
        this.addNewLock = false;
        this.addIndex = 0;
        this.resetIndex = 0;
        this.newDuration = 2;
        this.newDurationStatus = 0;

        // ⚙️ Configuration des classes
        this.photoClass = '.picture';
        this.slideClass = '.logo';

        // ⏭️ État de la navigation
        this.last = null;
        this.currentActive = null; // Cache pour le slide actif
        this.currentExclusive = null;

        // 📢 Gestion du Logo / Intercalaire
        this.logoDisableReinit = false;

        this.logoPage = 0;
        this.logoPageTotal = 0;

        // ⏱️ Vitesses et Timers
        this.queryDelay = this.data.queryDelay;

        // ⏲️ Intervalles et Timeouts
        this.interval = null;
        this.logoTimeout = null;
        this.logoTimeoutBefore = null;
        this.mediaInterval = null;

        // 🕰️ Temps serveur et compteurs
        this.timeServerNow = null;
        this.timeServerDiff = 0;
        this.timeCountdown = null;
        this.cycleCount = 0;

        // Colors
        this.backgroundColor = this.data.backgroundColor;
        this.backgroundColorCurrent = '#000000';

        // 📉 Performance
        this.fpsReductionFactor = 40;
        this.activeStages = new Set(); // Stocke les canvas DOM actifs
    }

    /**
     * 🚀 Initialisation du Presenter
     */
    init() {
        const myself = this;
        this.images = this.images || {};

        // 🔄 Initialisation des données pour toutes les animations
        this.show.find('> *').each(function() {
            $(this).data('played', 0);
            $(this).data('pause', -1);
            $(this).data('playedHourly', 0);
            $(this).data('lastHour', -1);
        })

        // 🎨 Initialisation des Canvas (Animations Adobe Animate)
        this.handleAnimations(global.animationData);

        // 📄 Initialisation des Slides HTML
        this.show.find('> div').each((index, element) => {
            const current = $(element);
            if (current.data('type') === 'html') {
                if (current.find('.progress__item').length > 1) {
                    current.addClass('progressable').data('pages', current.find('.progress__item').length - 1);
                }
                // slickSliderInit(current);
            }
        });

        // 📡 Configuration du Ticker Global (RAF pour performances max)
        createjs.Ticker.timingMode = createjs.Ticker.RAF;
        createjs.Ticker.addEventListener("tick", (e) => this.globalTick(e));

        // 📡 Première requête de fichiers
        this.queryFiles(true);
        setInterval(function(){ myself.queryFiles(); }, this.queryDelay);
        setInterval(function(){ myself.updateCanvasText(); }, 100);

        // ▶️ Démarrage du diaporama
        setTimeout(function () {
            // myself.forceDisplay($(myself.slideClass).first());
            myself.next();
        }, 500);

        // 🖱️ Navigation au clic
        $(window).click(function(){
            myself.next();
        });
    }

    /**
     * 🎨 Charge et prépare les animations Canvas (CreateJS / Adobe Animate)
     * @param {Array} animations Données des animations
     */
    handleAnimations(animations) {
        const myself = this;
        var canvas = [];
        var comp = [];
        var loader = [];

        animations.forEach(function(anim) {
            canvas[anim.id] = document.getElementById("anim-"+anim.id).querySelector('canvas');
            comp[anim.slug]=AdobeAn.getComposition(window.keyList[anim.slug]);
            var lib=comp[anim.slug].getLibrary();
            if (lib[anim.slug]) {
                loader[anim.slug] = new createjs.LoadQueue(false);
                loader[anim.slug].addEventListener("fileload", function(evt){myself.handleFileLoad(evt,comp[anim.slug])});
                loader[anim.slug].addEventListener("complete", function(evt){myself.handleComplete(evt,comp[anim.slug],canvas[anim.id],anim.slug)});
                var lib=comp[anim.slug].getLibrary();
                if (lib.properties.manifest.length) {
                    loader[anim.slug].loadManifest(lib.properties.manifest);
                }
                else {
                    myself.handleComplete({}, comp[anim.slug], canvas[anim.id], anim.slug);
                }
            }
            else {
                console.error('❌ CANVAS : Animation not found : ' + anim.slug);
            }
        });
    }

    /**
     * 📥 Gestionnaire de chargement de fichier pour CreateJS
     */
    handleFileLoad(evt, comp) {
        const images = comp.getImages();
        if (evt && evt.item.type === "image") { images[evt.item.id] = evt.result; }
    }

    /**
     * ✅ Gestionnaire de fin de chargement pour CreateJS
     */
    handleComplete(evt, comp, canvas, slug) {
        const lib = comp.getLibrary();
        const ss = comp.getSpriteSheet();
        const queue = evt.target;
        const ssMetadata = lib.ssMetadata;
        for (let i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({ "images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames });
        }

        this.exportRoot  = new lib[slug]();

        const stage = new createjs.Stage(canvas);
        stage.addChild(this.exportRoot);
        stage.update();

        createjs.Ticker.framerate = lib.properties.fps;
        $(canvas).data('fps', lib.properties.fps);
        $(canvas).parent().data('fps', lib.properties.fps);
        //createjs.Ticker.addEventListener("tick", stage);
        $(canvas).data('stage', stage);
        $(canvas).parent().data('stage', stage);
        $(canvas).data('exportRoot', this.exportRoot);
        $(canvas).data('listener', false);
        $(canvas).data('loaded', true);
        $(canvas).data('slug', slug);

        // Configuration initiale de performance pour le stage
        stage.tickEnabled = false;
        stage.mouseChildren = false;
        canvas.stage = stage;
        canvas.fpsRatio = 1;
    }

    /**
     * 🔄 Réinitialise une animation Canvas
     * @param {string} id ID de l'animation
     */
    reInit(id) {
        if (!this.logoDisableReinit) {
            const canvas = $('#anim-' + id + ' canvas');
            if (canvas.length) {
                this.log('🔄', 'CANVAS', `Initialisation de l'animation [${id}] : ${canvas.data('slug')}`);
                if (canvas.data('fps')) {
                    createjs.Ticker.framerate = canvas.data('fps');
                }
            }

            // Rembobiner l exportRoot
            if (canvas.data('exportRoot') && canvas.data('exportRoot').getChildAt(0) && canvas.data('exportRoot').getChildAt(0).gotoAndPlay) {
                canvas.data('exportRoot').getChildAt(0).gotoAndPlay(0);
            }
            // Rembobiner le stage
            if (canvas.data('stage') && canvas.data('stage').getChildAt(0) && canvas.data('stage').getChildAt(0).gotoAndPlay) {
                canvas.data('stage').getChildAt(0).gotoAndPlay(0);
            }

            if (canvas.data('loaded') && !canvas.data('listener')) {
                const canvasEl = canvas[0];
                canvasEl.fpsRatio = 1;
                canvasEl.tickCounter = 0;

                // Activation du stage
                const stage = canvas.data('stage');
                if (stage) {
                    stage.tickEnabled = true;
                    stage.mouseChildren = true;
                }

                this.activeStages.add(canvasEl);

                // 🚀 Relance du Ticker pour l'animation entrante
                if (createjs.Ticker.paused) createjs.Ticker.paused = false;

                canvas.data('listener', true);
                $('#anim-' + id).data('listener', true);

                // Mise à jour des textes dynamiques dans le canvas
                if (canvas.data('stage') && canvas.data('stage').getChildAt(0)) {
                    let interactiveText = canvas.data('stage').getChildAt(0).getChildByName('title');
                    if (interactiveText) {
                        interactiveText.text = canvas.data('title');
                    }
                    interactiveText = canvas.data('stage').getChildAt(0).getChildByName('text');
                    if (interactiveText) {
                        interactiveText.text = canvas.data('text');
                    }
                    const interactiveTextMain = canvas.data('stage').getChildAt(0).getChildByName('main');
                    if (interactiveTextMain) {
                        interactiveText = interactiveTextMain.getChildByName('title');
                        if (interactiveText) {
                            interactiveText.text = canvas.data('text');
                        }
                        interactiveText = interactiveTextMain.getChildByName('text');
                        if (interactiveText) {
                            interactiveText.text = canvas.data('text');
                        }
                    }
                }
            }
        } else {
            this.log('🚫', 'CANVAS', 'Réinitialisation désactivée (mode exclusif ou verrouillage actif)');
        }
    }

    /**
     * ⚙️ Gestionnaire de Tick Global
     * Centralise les mises à jour de tous les canvas actifs.
     */
    globalTick(e) {
        if (this.activeStages.size === 0) {
            if (!createjs.Ticker.paused) createjs.Ticker.paused = true;
            return;
        }

        this.activeStages.forEach(canvasEl => {
            const ratio = canvasEl.fpsRatio !== undefined ? canvasEl.fpsRatio : 1;
            if (ratio <= 0) return;

            canvasEl.tickCounter = (canvasEl.tickCounter || 0) + ratio;
            if (canvasEl.tickCounter >= 1) {
                if (canvasEl.stage) canvasEl.stage.update(e);
                canvasEl.tickCounter -= 1;
            }
        });
    }

    /**
     * 📝 Met à jour les textes des Canvas actifs (comptes à rebours, etc.)
     */
    updateCanvasText() {
        if (!this.currentActive || !this.currentActive.length) return;

        this.currentActive.each(function() {
            const $this = $(this);
            const countdown = $this.data('countdown');
            const dateStart = $this.data('date_start');

            const timeCountdownInfo = dateDist(countdown, dateStart);

            if ($this.hasClass('slide--canvas')) {
                const stage = $this.data('stage');
                if (stage && stage.getChildAt(0)) {
                    const root = stage.getChildAt(0);
                    // Update Title
                    let interactiveText = root.getChildByName('title');
                    if (interactiveText) interactiveText.text = $this.data('title');

                    // Update Text & Countdown
                    interactiveText = root.getChildByName('text');
                    if (interactiveText) {
                        let outText = $this.data('text') || '';
                        if (countdown) outText += timeCountdownInfo.launchMsg;
                        interactiveText.text = outText;
                    }
                }
            }
            $this.find('.slide__countdown').text(timeCountdownInfo.short);
            $this.data('timer', timeCountdownInfo);
        });
    }

    /**
     * 🔢 Ajoute des  zéros au début d'un nombre (Padding)
     */
    pad(num, size) {
        let numStr = num.toString();
        while (numStr.length < size) numStr = "0" + numStr;
        return numStr;
    }

    /**
     * 📡 Interroge le serveur pour obtenir la liste des fichiers à afficher
     */
    queryFiles(first) {
        $.ajax({
            dataType: "json",
            url: this.show.data('url'),
            success: (data) => {
                const now = new Date();

                // 🕰️ Mise à jour du temps serveur
                this.timeServerNow = new Date(data.now);
                this.timeServerDiff = now - this.timeServerNow;

                // ➕ Ajout des fichiers
                $.each(data.pictures, (index, value) => {
                    if (data.picturesName) {
                        this.imagesName[index] = data.picturesName[index];
                    }
                    if (!this.images[index]) {
                        this.addFile(index, value);
                    }
                });

                // ➖ Suppression des fichiers
                $.each(this.images, (index, value) => {
                    if (!data.pictures[index]) {
                        this.removeFile(index);
                    }
                });

                // 📢 Opérations sur les Logos / Animations
                $.each(data.animations, (index, animationMeta) => {
                    const currentAnim = $('#anim-' + index);
                    let slideActif = false;
                    if (animationMeta.actif) {
                        if ((!animationMeta.date_start || new Date(animationMeta.date_start) < now) && (!animationMeta.date_end || new Date(animationMeta.date_end) > now)) slideActif = true;
                    }

                    // Mise à jour des données du slide
                    currentAnim.data('title', animationMeta.title);
                    currentAnim.data('text', animationMeta.text);
                    currentAnim.data('date_start', animationMeta.date_start);
                    currentAnim.data('date_end', animationMeta.date_end);
                    currentAnim.data('countdown', animationMeta.countdown);
                    currentAnim.data('duration', animationMeta.duration);
                    currentAnim.data('overlay_logo', animationMeta.overlay_logo);
                    currentAnim.data('overlay_x', animationMeta.overlay_x);
                    currentAnim.data('overlay_y', animationMeta.overlay_y);
                    currentAnim.data('room_logo', animationMeta.room_logo);
                    currentAnim.data('room_x', animationMeta.room_x);
                    currentAnim.data('room_y', animationMeta.room_y);
                    currentAnim.data('cycle_skip', animationMeta.cycle_skip);
                    currentAnim.data('cycle_ofset', animationMeta.cycle_ofset);
                    currentAnim.data('cycle_perhourlimit', animationMeta.cycle_perhourlimit);
                    currentAnim.data('parent', animationMeta.parent);

                    currentAnim.data('anim_in', animationMeta.anim_in);
                    currentAnim.data('anim_in_duration', animationMeta.anim_in_duration);
                    currentAnim.data('anim_out', animationMeta.anim_out);
                    currentAnim.data('anim_out_duration', animationMeta.anim_out_duration);

                    if (currentAnim.css('background-color')) {
                        // currentAnim.css('background-color', animationMeta.color);
                    }

                    if (slideActif) {
                        currentAnim.removeClass('disabled');
                    } else {
                        currentAnim.addClass('disabled');
                    }

                    // Gestion de l'exclusivité
                    if (animationMeta.exclusive) {
                        if (!currentAnim.hasClass('exclusive')) {
                            currentAnim.addClass('exclusive');
                            this.next(); // Force le passage au suivant si devient exclusif
                        }
                    } else {
                        if (currentAnim.hasClass('exclusive')) {
                            currentAnim.removeClass('exclusive');
                            this.next();
                        }
                    }
                });

                if (first) {
                    this.addNewLock = false;
                }
            }
        });
    }

    /**
     * ➕ Ajoute un fichier (image) DOM
     */
    addFile(index, file) {
        this.log('➕', 'PHOTO', `Nouveau fichier détecté et ajouté à la file : ${file}`);
        this.images[index] = file;

        // Si pas de verrouillage, on planifie l'affichage de la nouvelle image
        if (!this.addNew && !this.addNewLock) {
            this.log('🆕', 'PHOTO', `Priorité d'affichage pour la nouvelle image à l'index : ${Object.keys(this.images).length - 1}`);
            this.addIndex = Object.keys(this.images).length - 1;
            this.addNew = true;
            this.addNewLock = true;
        }

        // Crée le DOM
        this.show.append('<div data-type="picture" id="picture-' + index + '" data-id="' + index + '" class="slide picture"><div class="slide__content" style="background-image:url(\'' + file + '\');"><div class="slide__label">' + this.imagesName[index] + '</div></div></div>');

        // Démarre l'intervalle si pas commencé
        if (!this.started && !this.interval) {
            this.interval = setInterval(() => { this.next(); this.log('⏰', 'TIME', 'Rotation automatique déclenchée'); }, this.photoDuration);
            this.started = true;
        }
    }

    /**
     * ➖ Supprime un fichier
     */
    removeFile(index, file) {
        this.log('🗑️', 'PHOTO', `Fichier supprimé de la collection : ${this.images[index]}`);
        delete this.images[index];
        $('#picture-' + index).remove();
    }

    /**
     * 🎬 Animation se termine bientôt
     */
    animationEndSoon() {
        if ($(this.last).data('exportRoot') && $(this.last).data('exportRoot').getChildAt(0) && $(this.last).data('exportRoot').getChildAt(0).gotoAndPlay) {
            $(this.last).data('exportRoot').getChildAt(0).play();
        }
    }

    /**
     * ➡️ Fonction Principale : Passe au slide suivant
     * C'est ici que toute la logique de choix du slide reside.
     */
    next() {
        let currentTime = new Date();

        // 🛑 Nettoyage des timers précédents
        clearTimeout(this.logoTimeout);
        clearInterval(this.mediaInterval);
        if (this.interval) clearInterval(this.interval);

        // Relance de l'intervalle par défaut
        this.interval = setInterval(() => { this.next(); this.log('⏰', 'TIME', 'Transition par intervalle standard'); }, this.photoDuration);

        // 🔍 Vérification des exclusivités (Priorité absolu)
        const exclusive = $('.exclusive:not(.disabled)');
        const exclusiveTotal = exclusive.length;

        let photoSelector = "#show " + this.photoClass;
        let slideSelector = "#show " + this.slideClass;
        let slideContainers = $(slideSelector);

        // Items counts
        this.slideTotal = slideContainers.length;
        this.photoTotal = $(photoSelector).length;

        // Skip mode change
        if (this.logoPage < this.logoPageTotal || exclusiveTotal) {
            this.slideMode = true;
            this.log('🖼️', 'MODE', 'Maintien du mode Diapositive (multi-pages ou exclusivité active)');
        }
        // Mode Diapositives
        else if ((this.slideMode && this.photoNb && this.photoTotal) || !this.slideNb || !this.slideTotal) {
            this.slideCounter++;
            this.photoCounter = 1;
        }
        // Mode photos
        else if ((!this.slideMode && this.slideNb && this.slideTotal) || !this.photoNb || !this.photoTotal) {
            this.photoCounter++;
            this.slideCounter = 1;
        }


        // switch mode photo
        if (this.slideMode &&(this.slideCounter > this.slideNb || !this.slideTotal) && this.photoTotal) {
            this.slideCounter = 1;
            this.slideMode = false;
            this.log('🖼️', 'MODE', 'Bascule en mode PHOTO');
        }
        // switch mode diapositives
        else if (!this.slideMode && (this.photoCounter > this.photoNb || !this.photoTotal) && this.slideTotal) {
            this.photoCounter = 1;
            this.slideMode = true;
            this.log('📽️', 'MODE', 'Bascule en mode DIAPOSITIVE');
        }

        // ⏳ Afficher les NOUVELLES photos plus longtemps
        if (this.newDurationStatus > 0) {
            this.newDurationStatus = this.newDurationStatus - 1;
            return false;
        }
        if (this.addNewLock) {
            this.newDurationStatus = this.newDuration;
        }

        // 👉 Préparation du suivant
        let current = null;
        let locked = false;

        // 📢 LOGIK LOGOS / INTERCALAIRES
        // On affiche un logo si :
        // - Compteur atteint la limite
        // - Exclusivité présente
        // - Pas d'intervalle défini
        // - Pas d'images régulières
        // - Multi-page logo en cours

        if (this.slideMode) {

            // On essaye de trouver un logo valide
            for (let logotry = 0; logotry < this.slideTotal; logotry++) {
                locked = true;

                // 📄 Gestion Multi-Pages
                if (this.logoPage < this.logoPageTotal) {
                    this.logoPage++;
                } else {
                    this.logoPage = 0;
                    this.slideCurrent++;
                    if (this.slideCurrent > this.slideTotal - 1) { this.slideCurrent = 0; }
                }

                // Cas 1️⃣ : Logo Exclusif
                if (exclusive.length) {
                    if (this.currentExclusive == exclusive.data('id')) this.logoDisableReinit = true;
                    else this.logoDisableReinit = false;

                    this.currentExclusive = exclusive.data('id');
                    current = exclusive;

                    this.log('🔒', 'SLIDE', 'Verrouillage par contenu exclusif actif');
                }

                // Cas 2️⃣ : Logo Normal (Rotation)
                else {
                    this.logoDisableReinit = false;
                    this.currentExclusive = null;
                    current = $(slideSelector + ":eq( " + this.slideCurrent + " )");
                }

                // 📊 Reset des stats horaires
                if (currentTime.getHours() != $(this).data('lastHour')) {
                    $(current).data('playedHourly', 0);
                    $(current).data('lastHour', currentTime.getHours());
                }

                // ⏯️ Gestion Pause Offset
                if ($(current).data('pause') == -1) {
                    $(current).data('pause', $(current).data('cycle_ofset'));
                }

                // ❌ Refusé par pause de cycle
                if ($(current).data('pause') > 0) {
                    this.log('🚫', 'SLIDE', `Pause de cycle active (${$(current).data('pause')} restants) : saut de [${current.data('id')}]`);
                    $(current).data('pause', $(current).data('pause')-1);
                }
                // ❌ Refusé par limite par heure
                else if ($(current).data('cycle_perhourlimit') > 0 && $(current).data('playedHourly') >= $(current).data('cycle_perhourlimit')) {
                    this.log('🚫', 'SLIDE', `Limite horaire atteinte (${$(current).data('cycle_perhourlimit')}) : saut de [${current.data('id')}]`);
                }
                // ❌ Est Inactif (Disabled)
                else if (current.hasClass('disabled')) {
                    this.log('🚫', 'SLIDE', `Slide désactivé : saut de [${current.data('id')}]`);
                }
                // ✅ Logo Validé !
                else {
                    break;
                }
            }

            // 📈 Mise à jour statistiques d'utilisation
            $(current).data('played', $(current).data('played')+1);
            $(current).data('playedHourly', $(current).data('playedHourly')+1);
            $(current).data('pause', $(current).data('cycle_skip'));

            // 🧹 Nettoyage Overlay Logo Legacy
            $('#overlay .overlay').each(function() {
                let currentOverlay = $(this);
                currentOverlay.addClass('overlay--disapear');
                setTimeout(function() {
                    currentOverlay.remove();
                }, 1000);
            });

            // 🖼️ Ajout Overlay Logo
            if (current.data('overlay_logo')) {
                let currentOverlay = $('<div class="overlay overlay--appear overlay--'+current.data('overlay_x')+' overlay--'+current.data('overlay_y')+'"><img src="'+current.data('overlay_logo')+'" style="object-position: '+current.data('overlay_x')+' '+current.data('overlay_y')+';" /></div>');
                $('#overlay').append(currentOverlay);
                setTimeout(function() {
                    currentOverlay.removeClass('overlay--appear');
                }, 100);
            }

            // 🧹 Nettoyage Overlay Room Legacy
            $('#room .overlay').each(function() {
                let currentOverlay = $(this);
                currentOverlay.addClass('overlay--disapear');
                setTimeout(function() {
                    currentOverlay.remove();
                }, 1000);
            });

            // 🏠 Ajout Overlay Room
            if (current.data('room_logo')) {
                let currentOverlay = $('<div class="overlay overlay--appear overlay--'+current.data('room_x')+' overlay--'+current.data('room_y')+'"><img src="'+current.data('room_logo')+'" style="object-position: '+current.data('room_x')+' '+current.data('room_y')+';" /></div>');
                $('#room').append(currentOverlay);
                setTimeout(function() {
                    currentOverlay.removeClass('overlay--appear');
                }, 100);
            }

            // 📄 Gestion Multi-Page interne
            this.logoPageTotal = current.data('pages');
            if (this.logoPageTotal) {
                this.animateOut(
                    current.find('.progress__item:visible').not(),
                    this.slideAnimOut,
                    this.slideAnimOutDuration,
                    null,
                    'subpages'
                );
                this.animateIn(
                    $(current.find('.progress__item').get(this.logoPage)),
                    this.slideAnimIn,
                    this.slideAnimInDuration,
                    'subpages'
                );
            }

            // ⏱️ Gestion Durée Spécifique
            if (current.data('duration')) {
                clearInterval(this.interval);
                clearTimeout(this.logoTimeout);
                clearTimeout(this.logoTimeoutBefore);
                this.interval = null;
                // Si pas vidéo (car vidéo gère sa propre fin)
                if (current.data('type') != 'video') {
                    this.logoTimeout = setTimeout(() => {
                        this.log('⏰', 'TIME', 'Durée du slide écoulée');
                        this.next();
                    }, current.data('duration'));
                    // Préviens l'animation qu'elle va finir
                    this.logoTimeoutBefore = setTimeout(() => {
                        this.log('⏰', 'TIME', 'Signal de fin de slide imminent');
                        this.animationEndSoon();
                    }, current.data('duration') - 1000);
                }
            }

            // 🔄 Réinitialisation de l'animation
            if (!this.logoDisableReinit) {
                $('#logo').fadeOut();
                this.reInit(current.data('id'));
            }
            this.updateBg(current.data('color'));
        }

        // 👋 Gestion Ancien Slide (Sortant)
        if (this.last && (!current || this.last.attr('id') != current.attr('id'))) {
            let last = this.last;
            if (current) {
                current.find('.progress__item').hide();
                current.find('.progress__item').first().show();
            }

            let callbackAnimate = () => {
                $(last).removeClass('active');
                // Stop Canvas Listener
                if ($(last).hasClass('anim')) {
                    if ($(last).data('listener') || $(last).find('canvas').data('listener')) {
                        const canvasEl = $(last).find('canvas')[0];
                        this.log('🧹', 'CLEANUP', `Déchargement des ressources Canvas pour [${last.data().id}]`);

                        if (canvasEl) {
                            this.activeStages.delete(canvasEl);
                            if (canvasEl.stage) {
                                canvasEl.stage.tickEnabled = false;
                                canvasEl.stage.mouseChildren = false;
                            }
                        }

                        $(last).data('listener', false);
                        $(last).find('canvas').data('listener', false);
                    }
                }
            };
            if (last.data('type') == 'picture') {
                this.animateOut(
                    last,
                    this.photoAnimOut,
                    this.photoAnimOutDuration,
                    callbackAnimate,
                    'picture'
                );
            }
            else {
                this.animateOut(
                    last,
                    last.data('anim_out') || this.slideAnimOut,
                    last.data('anim_out_duration') || this.slideAnimOutDuration,
                    callbackAnimate,
                    'regular'
                );
            }
        }

        // 🖼️ Slide Normal (Photos)
        if (!locked) { this.photoCurrent++; }

        // Saut vers nouvelle image
        if (this.addNew && !locked) {
            this.resetIndex = this.photoCurrent - 1;
            this.log('🦘', 'SLIDE', `Saut vers la nouvelle image à l'index : ${this.addIndex}`);
            this.photoCurrent = this.addIndex;
            this.addNew = false;
        }

        // Préparation si pas de logo sélectionné
        if (!current) {
            current = $(photoSelector + ":eq( " + this.photoCurrent + " )");
            this.updateBg(this.backgroundColor);
        }

        // 🔄 Boucle (Restart)
        if (!current.length) {
            this.photoCurrent = this.resetIndex;
            current = $(photoSelector + ":eq( " + this.photoCurrent + " )");
            this.resetIndex = 0;
            this.addNewLock = false;
            this.newDurationStatus = 0;
            this.log('🔄', 'SLIDE', `Boucle terminée, reprise à l'index : ${this.photoCurrent}`);
        }

        // 🎥 Playback Vidéo
        if (current.data('type') == 'video') {
            const video = current.find('video');
            if (video.length) {
                video[0].currentTime = 0;
                video[0].play();
                if (!this.slideMode) this.log('🎥', 'VIDEO', `Lecture de la vidéo à l'index : ${this.photoCurrent}`);
                this.mediaInterval = setInterval(() => {
                    this.videoTest(video[0]);
                }, 1000);
            }
        }

        // 🖼️ Iframe Show
        if (current.data('type') == 'iframe') {
            const iframe = current.find('iframe');
            if (iframe.length && iframe[0].contentWindow) {
                if (!this.slideMode) this.log('🖼️', 'IFRAME', `Affichage de l'iframe à l'index : ${this.photoCurrent}`);
                iframe[0].contentWindow.postMessage({ action: 'presenterShow' }, '*');
            }
        }

        // 📝 Remplacement Textes
        current.find('.slide__text').html(current.data('text'));
        if (!this.last || this.last.attr('id') != current.attr('id')) {
            current.find('.slide__text').hide().delay(100).fadeIn(2000);
        }
        current.find('.slide__title').html(current.data('title'));
        if (!this.last || this.last.attr('id') != current.attr('id')) {
            current.find('.slide__title').hide().delay(100).fadeIn(2000);
        }

        // ⏱️ Init Countdown
        this.timeCountdown = new Date(current.countdown);

        // ✨ Animation d'Entrée
        current.addClass('active');
        this.currentActive = $('.slide.active'); // Mise à jour du cache des slides actifs

        if (current.data('type') == 'picture') {
            this.animateIn(
                current,
                this.photoAnimIn,
                this.photoAnimInDuration,
                'picture'
            );
        }
        else {
            this.animateIn(
                current,
                current.data('anim_in') || this.slideAnimIn,
                current.data('anim_in_duration') || this.slideAnimInDuration,
                'regular'
            );
        }

        // 🖼️ Iframe Hide (on LAST slide)
        if (this.last && this.last.data('type') == 'iframe') {
            const iframe = this.last.find('iframe');
            if (iframe.length && iframe[0].contentWindow) {
                if (!this.slideMode) this.log('🖼️', 'IFRAME', `Envoi du signal de pause à l'iframe sortante : ${this.photoCurrent}`);
                iframe[0].contentWindow.postMessage({ action: 'presenterHide' }, '*');
            }
        }

        this.last = current;
        this.currentActive = $('.slide.active'); // Mise à jour finale du cache
        if (this.slideMode) {
            let pageMsg = (this.logoPageTotal > 0) ? ` (Page ${parseInt(this.logoPage) + 1} / ${parseInt(this.logoPageTotal) + 1})` : '';
            this.log('🚀', 'DISPLAY', `LANCEMENT DIAPOSITIVE [${current.data('type').toUpperCase()}] - ${this.slideCurrent} / ${this.slideTotal}${pageMsg}`);
        }
        else {
            this.log('📸', 'DISPLAY', `LANCEMENT PHOTO ${this.photoCurrent} / ${this.photoTotal} (Cycle ${this.photoCounter} / ${this.photoNb})`);
        }



        // 🎢 Resize Slick Sliders (si présents)
        setTimeout(() => {
            let sliders = current.find('.slick');
            sliders.each((i, slider) => {
                $(slider).slick('resize');
            });
        }, 100);
    }

    /**
     * ⚡ Force l'affichage d'un élément spécifique
     */
    forceDisplay(element) {
        this.next();
        // 👋 Gestion Sortie Ancien
        if (this.last && this.last.attr('id') != element.attr('id')) {
            this.animateOut(
                element,
                element.data('anim_out') || this.slideAnimOut,
                element.data('anim_out_duration') || this.slideAnimOutDuration,
                () => {
                    $(this.last).removeClass('active');
                    if ($(this.last).hasClass('anim')) {
                        if ($(this.last).data('listener') || $(this.last).find('canvas').data('listener')) {
                            const canvasEl = $(this.last).find('canvas')[0];
                            this.log('🧹', 'CLEANUP', `Libération forcée des ressources Canvas pour [${this.last.data().id}]`);

                            if (canvasEl) {
                                this.activeStages.delete(canvasEl);
                                if (canvasEl.stage) {
                                    canvasEl.stage.tickEnabled = false;
                                    canvasEl.stage.mouseChildren = false;
                                }
                            }

                            $(this.last).data('listener', false);
                            $(this.last).find('canvas').data('listener', false);
                        }
                    }
                },
                'force'
            );
        }
        // 👉 Set Index & Next
        this.photoCurrent = $(element).data('index');
        this.next();
        return false;
    }

    /**
     * 🎥 Vérifie si la vidéo est terminée
     */
    videoTest(video) {
        if (video.currentTime >= video.duration - 1) {
            clearInterval(this.mediaInterval);
            this.next();
        }
    }

    /**
     * ✨ Animation d'Entrée (Animate.css)
     */
    animateIn($el, animation, duration, log) {
        if (!$el || !$el.length || $el.hasClass('activated')) {
            // console.log('IN NO : ' + log);
            return;
        }
        else {
            // console.log('IN : ' + log);
        }

        // Content tag
        let $elContent = $el.find('> .slide__content');
        if (!$elContent.length) {
            $elContent = $el;
        }

        // 🔥 STOP ABSOLU
        clearTimeout($el.data('animtimeout'));
        $el.off('animationend');


        // Annule toute sortie en cours
        $el
            .stop(true, true)
            .removeClass('disapearing appearing animate__animated')
            .removeClass((i, c) => (c.match(/animate__\S+/g) || []).join(' '))
            .addClass('activated')
            .show();

        $elContent
            .stop(true, true)
            .removeClass('animate__animated')
            .removeClass((i, c) => (c.match(/animate__\S+/g) || []).join(' '))
            .show();

        // 📉 Gestion Z-index pour empilement propre
        $el.parent().children().not($el).each(function () {
            $(this).css('z-index', parseInt($(this).css('z-index')) - 1);
            $(this).removeClass('activated');
        });

        $el.css({
            'z-index': 10000,
            'animation-duration': duration + 'ms'
        });

        // 🧠 FORCER LE REFLOW (clé du bug d'animation)
        void $el[0].offsetWidth;

        // 🎬 Lancer l'animation
        $el
            .addClass('appearing animate__animated animate__' + animation)
            .one('animationend', () => {
                $el.removeClass('appearing');
            });
    }

    /**
     * 💨 Animation de Sortie (Animate.css)
     */
    animateOut($el, animation, duration, callback, log) {
        if (!$el || !$el.length) {
            // console.log('OUT NO : ' + log);
            return;
        }
        else {
            // console.log('OUT : ' + log);
        }

        // Content tag
        let $elContent = $el.find('> .slide__content');
        if (!$elContent.length) {
            $elContent = $el;
        }

        $elContent
            .stop(true, true)
            .removeClass((i, c) => (c.match(/animate__\S+/g) || []).join(' '))
            .css('animation-duration', duration + 'ms')
            .addClass('animate__animated animate__' + animation)

        $el
            .addClass('disapearing')
            .removeClass('activated');

        $el
            .data('animtimeout', setTimeout(() => {
                $el.removeClass('disapearing');
                $el.hide();

                // Pause des vidéos pour libérer des ressources
                $el.find('video').each(function() {
                    this.pause();
                });

                if (callback) callback();
                this.currentActive = $('.slide.active'); // Mise à jour du cache après disparition
            }, duration))

        // 📉 Descente progressive du framerate pour les animations Canvas
        const $canvas = $el.find('canvas');
        if ($el.hasClass('anim') && $canvas.length) {
            const canvasEl = $canvas[0];
            const steps = 20;
            const stepDuration = duration / steps;
            let currentStep = 0;


            const fpsInterval = setInterval(() => {
                currentStep++;
                const currentTime = currentStep * stepDuration;

                // Calcul du ratio de FPS basé sur le facteur de réduction
                const tZero = duration * (this.fpsReductionFactor / 100);
                let ratio = 1 - (currentTime / tZero);

                if (ratio < 0) ratio = 0;
                canvasEl.fpsRatio = ratio;

                // this.log('📉', 'CANVAS', 'Reduction ' + $el.data('id') + ' : ' + Math.round(ratio * 100) + '%');

                if (currentStep >= steps || ratio <= 0) {
                    clearInterval(fpsInterval);
                }
            }, stepDuration);
        }
    }

    updateBg(color) {
        if (this.backgroundColorCurrent != color) {
            this.log('🎨', 'BG', `Mise à jour de la couleur de fond : ${color}`);
            $('body').css('background-color', color);
            this.backgroundColorCurrent = color;
        }
    }

    /**
     * 📟 Système de Log Stylisé
     * @param {string} icon Emoji/Icone
     * @param {string} context Contexte (CANVAS, PHOTO, etc.)
     * @param {string} message Message à afficher
     * @param {string} [colorBg] Couleur de fond optionnelle
     * @param {string} [colorText] Couleur de texte optionnelle
     */
    log(icon, context, message, colorBg, colorText) {
        if (!this.debug) return;

        // Vérification des filtres de débogage
        if (this.debugOptions && this.debugOptions[context] === false) return;

        // Palette de couleurs par contexte
        const themes = {
            'DISPLAY':  { bg: '#3b82f6', text: '#ffffff' }, // Blue (Lancement)
            'CANVAS':   { bg: '#6366f1', text: '#ffffff' }, // Indigo
            'PHOTO':    { bg: '#10b981', text: '#ffffff' }, // Emerald
            'SLIDE':    { bg: '#3b82f6', text: '#ffffff' }, // Blue
            'MODE':     { bg: '#8b5cf6', text: '#ffffff' }, // Violet
            'TIME':     { bg: '#f59e0b', text: '#ffffff' }, // Amber
            'BG':       { bg: '#ec4899', text: '#ffffff' }, // Pink
            'VIDEO':    { bg: '#ef4444', text: '#ffffff' }, // Red
            'IFRAME':   { bg: '#14b8a6', text: '#ffffff' }, // Teal
            'CLEANUP':  { bg: '#6b7280', text: '#ffffff' }, // Gray
            'ERROR':    { bg: '#000000', text: '#f87171' }  // Black/Red
        };

        const theme = themes[context] || {
            bg: colorBg || '#4b5563',
            text: colorText || '#ffffff'
        };

        const timestamp = new Date().toLocaleTimeString('fr-FR', { hour12: false });

        console.log(
            `%c ${icon} %c ${timestamp} %c ${context.padEnd(8)} %c ${message}`,
            `background: ${theme.bg}; color: ${theme.text}; font-weight: bold; border-radius: 3px 0 0 3px; padding: 2px 0;`,
            `background: #1f2937; color: #9ca3af; padding: 2px 5px; font-family: monospace;`,
            `background: ${theme.bg}; color: ${theme.text}; font-weight: bold; padding: 2px 5px;`,
            `color: ${theme.bg}; font-weight: 500; padding: 2px 5px;`
        );
    }
}
